import { Component, Input, OnInit } from '@angular/core';
import { Actions, UserActions } from '../../models/user-actions';
import { ConfigService } from '../../services/config.service';
import { ApiService } from '../../services/api.service';
import { UserBookClubsCollection } from '../../models/user-book-clubs-collection';
import { UserActionsBookClubsComponent } from '../user/user-actions-book-clubs/user-actions-book-clubs.component';
import { AuthService } from '../../services/auth.service';
import { LocaleService } from 'src/app/services/locale.service';
import { Router } from '@angular/router';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  selector: 'app-slider-user-actions',
  templateUrl: './slider-user-actions.component.html',
  styleUrls: ['./slider-user-actions.component.scss'],
})
export class SliderUserActionsComponent extends UserActionsBookClubsComponent implements OnInit {
  readonly swiperConfig: SwiperOptions = {
    breakpoints: undefined,
    slidesPerView: 'auto',
    spaceBetween: 16,
    grabCursor: true,
    navigation: {
      enabled: false,
    }
  };

  @Input()
  userActions: UserActions[] = [];
  bookSection = 'section=';
  bookClubs: UserBookClubsCollection;
  textDirection: string;

  canCreateUserGroups: boolean;

  constructor(
    configService: ConfigService,
    public apiService: ApiService,
    public authService: AuthService,
    private localeService: LocaleService,
    private readonly router: Router,
  ) {
    super(configService, authService, apiService);
  }

  ngOnInit() {
    this.canCreateUserGroups = this.userFacade.user.canCreateUserGroups;
    this.textDirection = this.localeService.getTextDirection();
  }

  executeAction(action: string) {
    if (Actions.CREATE_BOOKCLUB === action) {
      this.goToBookClub(action);
    }
  }

  goToCreateGroup() {
    this.router.navigate(['/user', 'account'], {
      queryParams: { createGroup: true },
    });
  }
}
